export default "__VITE_ASSET__yaT$$0aH__"